export default __webpack_public_path__ + "static/media/logo.ede1a6b6.svg";